import { render, staticRenderFns } from "./CreateOwnCourse.vue?vue&type=template&id=0debaa7c"
import script from "./CreateOwnCourse.vue?vue&type=script&lang=js"
export * from "./CreateOwnCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateOwnCourse.vue?vue&type=style&index=0&id=0debaa7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports